import type { ImpactAnalysisData } from "../types/impact-analysis";

// Impact analysis processing steps
export const IMPACT_ANALYSIS_STEPS: string[] = [
  "Analizarea datelor companiei...",
  "Evaluarea impactului sectorial...",
  "Analiza dependențelor critice...",
  "Calcularea scorului de risc...",
  "Determinarea clasificării finale...",
  "Generarea recomandărilor...",
];

// NIS2 Classification evaluation steps
export const NIS2_EVALUATION_STEPS: string[] = [
  "Verificare dimensiune entitate",
  "Analiza sectoare de activitate",
  "Verificare criterii excepționale",
  "Aplicare algoritm clasificare",
  "Determinare necesitate analiză impact",
];

export type ImpactAnalysisStep = string;
export type NIS2EvaluationStep = string;

export const MIN_LOADING_DURATION_MS = 3500;

export const DEFAULT_IMPACT_ANALYSIS: ImpactAnalysisData = {
  section1_mandatory: {
    is_sole_essential_provider: null,
    is_sole_essential_provider_explanation: null,
    formally_designated: null,
    formally_designated_explanation: null,
  },
  section2_public_impact: {
    fundamental_rights: {
      personal_data_affected: null,
      personal_data_affected_explanation: null,
      public_service_access_lost: null,
      public_service_access_lost_explanation: null,
    },
    national_economy: {
      gdp_loss_over_threshold: null,
      gdp_loss_over_threshold_explanation: null,
      affects_other_sector_services: null,
      affects_other_sector_services_explanation: null,
      highest_sector_impact_percentage: null,
      highest_sector_impact_percentage_explanation: null,
      affects_critical_infrastructure: null,
      affects_critical_infrastructure_explanation: null,
    },
    health_life: {
      can_cause_death: null,
      can_cause_death_explanation: null,
      chronic_illness_or_disability: null,
      chronic_illness_or_disability_explanation: null,
      traumatic_injuries_or_health_impact: null,
      traumatic_injuries_or_health_impact_explanation: null,
    },
    financial_impact: {
      people_financial_loss: null,
      people_financial_loss_explanation: null,
    },
    defense_security: {
      affects_defense_capacity: null,
      affects_defense_capacity_explanation: null,
      generates_state_incapacity: null,
      generates_state_incapacity_explanation: null,
      damages_state_reputation: null,
      damages_state_reputation_explanation: null,
    },
  },
  section3_systemic_risk: {
    affects_other_sectors: null,
    affects_other_sectors_explanation: null,
    affected_sectors_count: null,
    highest_impact_percentage: null,
    highest_impact_percentage_explanation: null,
    affects_international_obligations: null,
    affects_international_obligations_explanation: null,
  },
};
